(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfRangeDatepicker', [
    '$parse', function($parse) {
      return {
        scope: {
          options: '=',
          year: '=',
          minYear: '=',
          maxYear: '=',
          limitYearFilter: '='
        },
        require: 'ngModel',
        link: function(scope, ele, attrs, ngModel) {
          var base, base1, base2, base3, end_date, initial_value, parseVal, ref, setMinMaxYear, start_date;
          if (scope.options == null) {
            scope.options = {};
          }
          if ((base = scope.options).autoApply == null) {
            base.autoApply = true;
          }
          if ((base1 = scope.options).linkedCalendars == null) {
            base1.linkedCalendars = true;
          }
          if ((base2 = scope.options).autoUpdateInput == null) {
            base2.autoUpdateInput = true;
          }
          if ((base3 = scope.options).parentEl == null) {
            base3.parentEl = '#bs2-container';
          }
          parseVal = function(val) {
            if (!val) {
              return [];
            }
            if (typeof val === 'object') {
              return [val.startDate, val.endDate];
            } else {
              return val.split(' - ');
            }
          };
          initial_value = $parse(attrs.ngModel)(scope.$parent.$parent);
          if (initial_value && scope.options.autoApply) {
            ref = parseVal(initial_value), start_date = ref[0], end_date = ref[1];
            if (start_date != null) {
              scope.options.startDate = start_date;
            }
            if (end_date != null) {
              scope.options.endDate = end_date;
            }
          }
          ele.daterangepicker(scope.options);
          scope.$parent.$parent.$watch(attrs.ngModel, function(val) {
            var datepicker, ref1;
            ref1 = parseVal(val), start_date = ref1[0], end_date = ref1[1];
            datepicker = ele.data('daterangepicker');
            if (start_date != null) {
              datepicker.setStartDate(start_date);
            }
            if (end_date != null) {
              return datepicker.setEndDate(end_date);
            }
          }, true);
          ele.on('apply.daterangepicker', (function(_this) {
            return function(ev, picker) {
              ngModel.$setViewValue({
                startDate: picker.startDate,
                endDate: picker.endDate
              });
              if (!scope.options.autoUpdateInput) {
                return ele.val((picker.startDate.format('MM/DD')) + " - " + (picker.endDate.format('MM/DD')));
              }
            };
          })(this));
          if (initial_value && scope.options.autoApply) {
            ele.trigger('apply.daterangepicker', ele.data('daterangepicker'));
          }
          setMinMaxYear = (function(_this) {
            return function(years) {
              var datepicker, endDate, max_year, min_year, startDate;
              datepicker = ele.data('daterangepicker');
              if ((years != null ? years.length : void 0) > 0) {
                min_year = _.min(years);
                max_year = _.max(years);
                datepicker.minDate = moment(min_year + "-1-1", 'YYYY-MM-DD');
                datepicker.maxDate = moment(max_year + "-12-31", 'YYYY-MM-DD');
                startDate = datepicker.startDate;
                endDate = datepicker.endDate;
                if (startDate.isAfter(datepicker.maxDate)) {
                  datepicker.setStartDate(startDate.year(max_year));
                }
                if (endDate.isAfter(datepicker.maxDate)) {
                  datepicker.setEndDate(endDate.year(max_year));
                }
                if (endDate.isBefore(datepicker.minDate)) {
                  datepicker.setEndDate(endDate.year(min_year));
                }
                if (startDate.isBefore(datepicker.minDate)) {
                  return datepicker.setStartDate(startDate.year(min_year));
                }
              } else {
                datepicker.minDate = false;
                return datepicker.maxDate = false;
              }
            };
          })(this);
          if (scope.year != null) {
            scope.$watch('year', function(newYear, oldYear) {
              return setMinMaxYear([newYear]);
            });
          }
          if (scope.minYear != null) {
            scope.$watch('minYear', function(newYear, oldYear) {
              return setMinMaxYear([newYear, scope.maxYear]);
            });
          }
          if (scope.maxYear != null) {
            scope.$watch('maxYear', function(newYear, oldYear) {
              return setMinMaxYear([scope.minYear, newYear]);
            });
          }
          if (scope.limitYearFilter != null) {
            return scope.$watchCollection((function(_this) {
              return function() {
                var i, len, ref1, ref2, results, year;
                ref2 = (ref1 = scope.limitYearFilter.selected_values) != null ? ref1 : [];
                results = [];
                for (i = 0, len = ref2.length; i < len; i++) {
                  year = ref2[i];
                  results.push(year.key);
                }
                return results;
              };
            })(this), setMinMaxYear);
          }
        }
      };
    }
  ]);

}).call(this);
